import { ExtensionType } from "backend/src/common/types/ExtensionCard";
import { GeneralMessageKey } from "backend/src/common/i18n/messages";

export const START_STEP_KEYS: GeneralMessageKey[] = [
  "start.step.1",
  "start.step.2",
  "start.step.3",
];

export const START_NEXT_STEP_KEYS: GeneralMessageKey[] = [
  "start.next.1",
  "start.next.2",
  "start.next.3",
];

export const START_QUICK_RULE_KEYS: GeneralMessageKey[] = [
  "start.rule.1",
  "start.rule.2",
  "start.rule.3",
];

export const RULES_CARD_GROUPS: Array<{
  titleKey: GeneralMessageKey;
  introKey: GeneralMessageKey;
  cards: ExtensionType[];
}> = [
  {
    titleKey: "rules.group.feedingEconomy.title",
    introKey: "rules.group.feedingEconomy.intro",
    cards: [
      ExtensionType.chlorophyll,
      ExtensionType.aedificator,
      ExtensionType.crazing,
      ExtensionType.hibernation,
      ExtensionType.scavenger,
      ExtensionType.piracy,
      ExtensionType.fat,
      ExtensionType.cooperation,
      ExtensionType.communication,
    ],
  },
  {
    titleKey: "rules.group.predators.title",
    introKey: "rules.group.predators.intro",
    cards: [
      ExtensionType.predator,
      ExtensionType.sharpVision,
      ExtensionType.intellect,
      ExtensionType.angler,
    ],
  },
  {
    titleKey: "rules.group.protection.title",
    introKey: "rules.group.protection.intro",
    cards: [
      ExtensionType.camouflage,
      ExtensionType.swimming,
      ExtensionType.big,
      ExtensionType.transparent,
      ExtensionType.burrowing,
      ExtensionType.running,
      ExtensionType.poisonous,
      ExtensionType.pseudoPoisonous,
      ExtensionType.spikes,
      ExtensionType.horns,
      ExtensionType.tailLoss,
      ExtensionType.fly,
      ExtensionType.ink,
      ExtensionType.scream,
      ExtensionType.patron,
      ExtensionType.immunity,
      ExtensionType.shell,
    ],
  },
  {
    titleKey: "rules.group.parasites.title",
    introKey: "rules.group.parasites.intro",
    cards: [
      ExtensionType.parasite,
      ExtensionType.parasitePair,
      ExtensionType.tumor,
    ],
  },
  {
    titleKey: "rules.group.reproduction.title",
    introKey: "rules.group.reproduction.intro",
    cards: [
      ExtensionType.viviparous,
      ExtensionType.layingEggs,
      ExtensionType.egg,
    ],
  },
];

export const RULES_CARD_DETAIL_KEYS: Record<
  ExtensionType,
  [GeneralMessageKey, GeneralMessageKey, GeneralMessageKey]
> = {
  [ExtensionType.predator]: [
    "rules.detail.predator.1",
    "rules.detail.predator.2",
    "rules.detail.predator.3",
  ],
  [ExtensionType.camouflage]: [
    "rules.detail.camouflage.1",
    "rules.detail.camouflage.2",
    "rules.detail.camouflage.3",
  ],
  [ExtensionType.sharpVision]: [
    "rules.detail.sharpVision.1",
    "rules.detail.sharpVision.2",
    "rules.detail.sharpVision.3",
  ],
  [ExtensionType.swimming]: [
    "rules.detail.swimming.1",
    "rules.detail.swimming.2",
    "rules.detail.swimming.3",
  ],
  [ExtensionType.running]: [
    "rules.detail.running.1",
    "rules.detail.running.2",
    "rules.detail.running.3",
  ],
  [ExtensionType.big]: [
    "rules.detail.big.1",
    "rules.detail.big.2",
    "rules.detail.big.3",
  ],
  [ExtensionType.crazing]: [
    "rules.detail.crazing.1",
    "rules.detail.crazing.2",
    "rules.detail.crazing.3",
  ],
  [ExtensionType.poisonous]: [
    "rules.detail.poisonous.1",
    "rules.detail.poisonous.2",
    "rules.detail.poisonous.3",
  ],
  [ExtensionType.tailLoss]: [
    "rules.detail.tailLoss.1",
    "rules.detail.tailLoss.2",
    "rules.detail.tailLoss.3",
  ],
  [ExtensionType.hibernation]: [
    "rules.detail.hibernation.1",
    "rules.detail.hibernation.2",
    "rules.detail.hibernation.3",
  ],
  [ExtensionType.scavenger]: [
    "rules.detail.scavenger.1",
    "rules.detail.scavenger.2",
    "rules.detail.scavenger.3",
  ],
  [ExtensionType.burrowing]: [
    "rules.detail.burrowing.1",
    "rules.detail.burrowing.2",
    "rules.detail.burrowing.3",
  ],
  [ExtensionType.piracy]: [
    "rules.detail.piracy.1",
    "rules.detail.piracy.2",
    "rules.detail.piracy.3",
  ],
  [ExtensionType.parasite]: [
    "rules.detail.parasite.1",
    "rules.detail.parasite.2",
    "rules.detail.parasite.3",
  ],
  [ExtensionType.parasitePair]: [
    "rules.detail.parasitePair.1",
    "rules.detail.parasitePair.2",
    "rules.detail.parasitePair.3",
  ],
  [ExtensionType.cooperation]: [
    "rules.detail.cooperation.1",
    "rules.detail.cooperation.2",
    "rules.detail.cooperation.3",
  ],
  [ExtensionType.communication]: [
    "rules.detail.communication.1",
    "rules.detail.communication.2",
    "rules.detail.communication.3",
  ],
  [ExtensionType.fat]: [
    "rules.detail.fat.1",
    "rules.detail.fat.2",
    "rules.detail.fat.3",
  ],
  [ExtensionType.fly]: [
    "rules.detail.fly.1",
    "rules.detail.fly.2",
    "rules.detail.fly.3",
  ],
  [ExtensionType.angler]: [
    "rules.detail.angler.1",
    "rules.detail.angler.2",
    "rules.detail.angler.3",
  ],
  [ExtensionType.pseudoPoisonous]: [
    "rules.detail.pseudoPoisonous.1",
    "rules.detail.pseudoPoisonous.2",
    "rules.detail.pseudoPoisonous.3",
  ],
  [ExtensionType.viviparous]: [
    "rules.detail.viviparous.1",
    "rules.detail.viviparous.2",
    "rules.detail.viviparous.3",
  ],
  [ExtensionType.layingEggs]: [
    "rules.detail.layingEggs.1",
    "rules.detail.layingEggs.2",
    "rules.detail.layingEggs.3",
  ],
  [ExtensionType.egg]: [
    "rules.detail.egg.1",
    "rules.detail.egg.2",
    "rules.detail.egg.3",
  ],
  [ExtensionType.ink]: [
    "rules.detail.ink.1",
    "rules.detail.ink.2",
    "rules.detail.ink.3",
  ],
  [ExtensionType.spikes]: [
    "rules.detail.spikes.1",
    "rules.detail.spikes.2",
    "rules.detail.spikes.3",
  ],
  [ExtensionType.scream]: [
    "rules.detail.scream.1",
    "rules.detail.scream.2",
    "rules.detail.scream.3",
  ],
  [ExtensionType.patron]: [
    "rules.detail.patron.1",
    "rules.detail.patron.2",
    "rules.detail.patron.3",
  ],
  [ExtensionType.transparent]: [
    "rules.detail.transparent.1",
    "rules.detail.transparent.2",
    "rules.detail.transparent.3",
  ],
  [ExtensionType.horns]: [
    "rules.detail.horns.1",
    "rules.detail.horns.2",
    "rules.detail.horns.3",
  ],
  [ExtensionType.aedificator]: [
    "rules.detail.aedificator.1",
    "rules.detail.aedificator.2",
    "rules.detail.aedificator.3",
  ],
  [ExtensionType.immunity]: [
    "rules.detail.immunity.1",
    "rules.detail.immunity.2",
    "rules.detail.immunity.3",
  ],
  [ExtensionType.intellect]: [
    "rules.detail.intellect.1",
    "rules.detail.intellect.2",
    "rules.detail.intellect.3",
  ],
  [ExtensionType.tumor]: [
    "rules.detail.tumor.1",
    "rules.detail.tumor.2",
    "rules.detail.tumor.3",
  ],
  [ExtensionType.shell]: [
    "rules.detail.shell.1",
    "rules.detail.shell.2",
    "rules.detail.shell.3",
  ],
  [ExtensionType.chlorophyll]: [
    "rules.detail.chlorophyll.1",
    "rules.detail.chlorophyll.2",
    "rules.detail.chlorophyll.3",
  ],
};
